import React, { PureComponent } from 'react';
import Mapbox from './shared/mapbox/index';
import BookingHighLights from './booking-highlights';
import SlacklaWidget from '../components/shared/stackla-widget';
import { authToken } from '../actions/utils';
import { FetchBooking } from '../actions/booking'
import { withApollo } from 'react-apollo'; 
import { connect } from 'react-redux';
import { SetDeparture } from '../actions/departures';
import { bindActionCreators } from 'redux';
import dayjs from 'dayjs';
import _orderBy from 'lodash/orderBy';

class App extends PureComponent {

  constructor(){
    super();
    this.state = {
      isReady:false
    }
  }

  async componentDidMount(){

    const { departures, uuid } = document.getElementById("ap-popular-itineraries").dataset;

    //Scroll window to top
    window.scrollTo(0, 0);
    
    //Save departures fom data attribute
    if(departures !== undefined && departures !== ""){
      const orderDates = _orderBy(departures.split(";"), (item) => { return dayjs(item).format('YYYY-MM-DD') });
      this.props.SetDeparture(orderDates);
    }
    
    //Get auth token
    await authToken();

    //Fetch booking
    if(uuid !== undefined){
      const response = await FetchBooking(this.props.client, uuid);
      if(response){
        if(departures === undefined || departures === "") this.props.SetDeparture(response.data.getBooking.alternateDepartures);
        this.setState({isReady:true});
      } 
    }

  }

  render(){

    if(!this.state.isReady) return null;

    const { itinerary, toggleCollapse } = this.props; 
    const _mapBoxSequence = (itinerary !== undefined && itinerary.length > 0) ? itinerary : [];    


    return (
      <>
        <div className="max-width-5 mx-auto clearfix popular-itineraries">
          <div className="col col-12 md-col-6 px2 mb3"></div>

          <div className="col col-12 md-col-6 px2">
            <BookingHighLights />
          </div>
        </div>

        <div className="margin-t-50">
          <Mapbox countriesShow={_mapBoxSequence} clickable={true} isItinerary={false} id={"mapContainer"} isCollapse={toggleCollapse}/>
        </div>

        <div className="max-width-5 mx-auto popular-itineraries margin-t-100">
          <div className="clearfix">
            <div className="col col-12 px2 center">
              <p className="pb2 f-size-20">Real and genuine moments <span className="bold">captured by our travellers</span></p>
              <p className="">Instagram moments to make your friends jealous on this trip</p>
            </div>
          </div>
          <div className="clearfix margin-t-70 margin-b-100">
            <div className="col col-12 px2 center">
              <SlacklaWidget />
            </div>
          </div>
        </div>
      </>
    )
  }
}

const mapStateToProps = state => {
  return{
      itinerary:state.currentBooking.itinerary,
      toggleCollapse:state.toggleCollapse
  }
}

const mapDispatchToProps = dispatch => {
  return bindActionCreators({
    SetDeparture
  }, dispatch);
}

export default withApollo(connect(mapStateToProps, mapDispatchToProps)(App));